import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleQuestion } from "@abodeminehq/parcel-ui/icons/fa/pro-solid";
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { DocumentEditor } from '~/components/app/documentation/guides/editors/editor'
import { ContentUnavailableView } from '~/components/layouts/ContentUnavailableView'
import { useAuthScopes } from '~/hooks/use-auth-scopes'
import { LogtoScopes } from '~/lib/logto/logto'

export const Route = createFileRoute('/docs/guide/$slug/edit')({
  component: DocumentEditPage,
})

function DocumentEditPage() {
  const navigate = useNavigate()
  const { slug } = Route.useParams()
  const hasGuideWriteScopes = useAuthScopes(LogtoScopes.GuideWrite)

  const isNewDocument = !slug || slug === 'new'
  const documentSlug = isNewDocument ? undefined : slug

  if (!hasGuideWriteScopes) {
    return (
      <div className="flex-1 flex justify-center items-center">
        <ContentUnavailableView
          title="Access Denied"
          description="You don't have permission to edit guides"
          icon={faCircleQuestion}
        />
      </div>
    )
  }

  return (
    <div className="flex-1 flex flex-col">
      <div className="border-b p-4">
        <div className="flex items-center gap-4">
          
          <h1 className="text-2xl font-bold">
            {isNewDocument ? 'New Document' : 'Edit Document'}
          </h1>
          
          {/* {!isNewDocument && hasGuideWriteScopes && (
            <Button
              variant="outline"
              size="sm"
              onClick={() => navigate({ to: `/docs/guide/${slug}` })}
              className="flex items-center gap-2"
            >
              <Eye className="h-4 w-4" />
              View
            </Button>
          )} */}
        </div>
      </div>

      <div className="flex-1 overflow-auto p-6">
        <DocumentEditor
          documentSlug={documentSlug}
          onBack={() => navigate({ to: '/docs/guide' })}
        />
      </div>
    </div>
  )
}
